import { polarToCartesian } from '../../utils/describe-arc-segment';
import type { PassFailStartCapProps } from '../../types';

/**
 * Restores a rounded start cap for pass/fail mode when the main progress path
 * uses a butt line cap at the threshold endpoint.
 */
export const PassFailStartCap: React.FC<PassFailStartCapProps> = ({
  color,
  rotation,
  strokeWidth,
}) => {
  const startAngle = rotation * 360 - 90;
  const arcRadius = 50 - strokeWidth / 2;
  const pt = polarToCartesian(50, 50, arcRadius, startAngle);

  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-full w-full"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 100 100"
    >
      <circle cx={pt.x} cy={pt.y} fill={color} r={strokeWidth / 2} />
    </svg>
  );
};

PassFailStartCap.displayName = 'PassFailStartCap';

export default PassFailStartCap;
